<template>
    <v-group :config="{ listening: false }">
        <v-line :config="lineConfig"></v-line>

        <Angle v-if="angleStartPoint"
               :pointCenter="fromPoint"
               :angleDirectionStart="angle.angleDirectionStart"
               :angleSize="angle.angleSize"
        ></Angle>

        <LineSize
                :fromPoint="fromPoint"
                :toPoint="toPoint"
                :color="lineColor"
        ></LineSize>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import LineSize from "./LineSize";
    import Angle from "./Angle";

    export default {
        name: "DrawingLine",

        components: {
            Angle,
            LineSize
        },

        props: [
            'fromPoint',
            'toPoint',
            'lineColor',
        ],

        computed: {
            ...mapState('editor', [
                'points',
            ]),

            ...mapGetters('angles', [
                'getAngles',
            ]),

            lineConfig() {
                let xFrom = this.fromPoint.x;
                let yFrom = this.fromPoint.y;
                let xTo = this.toPoint.x;
                let yTo = this.toPoint.y;
                let points = [xFrom, yFrom, xTo, yTo];

                return {
                    name: 'DrawingLine',
                    points,
                    stroke: this.lineColor,
                    strokeWidth: 3,
                    lineCap: 'round',
                    lineJoin: 'round',
                }
            },

            angleStartPoint() {
                const points = this.points;

                if (!points.length) return null;

                const angelCenterPoint = this.fromPoint;

                // for the drawing line the angle Center point can be only on one of the current trim edges.
                // So first need to get the edge points:
                const openPoint = points[0];
                const closePoint = points[points.length - 1];

                // and than check on which edge the Center point are.
                // For find the Start point of the angle, which is the next after Center point
                if (+angelCenterPoint.id === +openPoint.id) {
                    return points[1];
                }
                else if (+angelCenterPoint.id === +closePoint.id) {
                    return points[points.length - 2];
                }

                console.warn(`Can't find angleStartPoint for the DrawingLine`);
                return null;
            },

            angle() {
                let points = [this.angleStartPoint, this.fromPoint, this.toPoint];

                let anglesArray = this.getAngles(points);

                return anglesArray[0];
            },

        },

    }
</script>

<style scoped>

</style>